import React from "react";
import Navbar from "../components/Navbar/Navbar";
import "./Contact.css";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

function Contact() {
  return (
    <>
      <Navbar />
      <div className="container mt-5">
        <div className="row align-items-center justify-content-center">
          <p className="text-start">Get in touch</p>
          <hr className="" />
          <p className="text-start contact-text mb-5">
            Contrary to popular belief, Lorem Ipsum is not simply random text.
            It has roots in a piece of classical Latin literature from 45 BC. t
            is a long established fact that a reader will be distracted by the
            readable content of a page when looking at its layout.
          </p>

          <div className="col-6">
            <Form id="contact-form">
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" />
              </Form.Group>
              <Form.Label>Message</Form.Label>
              <Form.Control as="textarea" style={{ height: "100px" }} />

              <Button
                id="contact-button"
                className="mt-4"
                variant="dark"
                type="submit"
              >
                Submit
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
